import { React, useContext, useState } from 'react';
import './styles.css';
import { LabelForm } from '../LabelForm';
//import { InputText } from '../InputText';
import { Button } from '../Button';
import { SaveUser, ValidarEmail, ValidarCPF } from '../../utils/utils';
import P from 'prop-types';
import { GlobalContext } from '../../contexts/HomeContext';
import { Modal } from '../Modal';
import { toast } from 'react-toastify';
import { SalvarDadosCliente } from '../../utils/api/api';
import { useForm } from 'react-hook-form';

export const MeusDados = ({ closeModal }) => {
  const { dadosApp, user, setUser } = useContext(GlobalContext);
  const [modalExcluirConta, setModalExcluirConta] = useState('none');
  const [modalSMS, setModalSMS] = useState('none');
  const [modalLoading, setModalLoading] = useState(false);
  const isLogged = user.id > 0 && !user.email.includes('pedido_');

  const handleGetDefaults = () => {
    if (isLogged) {
      let retorno = { ...user };
      retorno.idloja = dadosApp.IdLoja;
      retorno.empresa_fantasia = dadosApp.Empresa.Empresa.fantasia;
      retorno.empresa_razao = dadosApp.Empresa.Empresa.razao;
      retorno.sexo = user.sexo.substring(0, 1);
      retorno.telefone = user.telefone_ddd + user.telefone;
      retorno.data_aniversario = user.data_aniversario == '2011-01-01' ? '0001-01-01' : user.data_aniversario;

      return retorno;
    } else {
      const retorno = {
        id: 0,
        idloja: dadosApp.IdLoja,
        nome: '',
        sobrenome: '',
        nome_completo: '',
        email: '',
        senha: '',
        telefone_ddd: '',
        telefone: '',
        empresa_fantasia: dadosApp.Empresa.Empresa.fantasia,
        empresa_razao: dadosApp.Empresa.Empresa.razao,
        data_aniversario: '2011-01-01',
        cpf: '',
        sexo: 'M',
      };
      return retorno;
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: handleGetDefaults(),
  });

  const [dados, setDados] = useState({});
  // const [dados, setDados] = useState({
  //   id: 0,
  //   idloja: dadosApp.IdLoja,
  //   nome: '',
  //   sobrenome: '',
  //   nome_completo: '',
  //   email: '',
  //   senha: '',
  //   telefone_ddd: '',
  //   telefone: '',
  //   empresa_fantasia: dadosApp.Empresa.Empresa.fantasia,
  //   empresa_razao: dadosApp.Empresa.Empresa.razao,
  //   data_aniversario: '2011-01-01',
  //   cpf: '',
  //   sexo: 'M',
  // });

  const showHideModalSMS = () => {
    setModalSMS(modalSMS == 'none' ? 'block' : 'none');
  };

  const showHideModalExcluirConta = () => {
    setModalExcluirConta(modalExcluirConta == 'none' ? 'block' : 'none');
  };

  const handleDadosEnvio = (dadosEnvio) => {
    let retorno = { ...dadosEnvio };

    var temp = dadosEnvio.nome_completo.split(' ');

    retorno.telefone_ddd = dadosEnvio.telefone.substring(0, 2);
    retorno.telefone = dadosEnvio.telefone.substring(2);
    retorno.nome = temp.length > 0 ? temp[0] : '';
    retorno.sobrenome = temp.length > 1 ? temp[1] : '';
    // retorno['nome'] = dadosEnvio.nome_completo.substring(0, dadosEnvio.nome_completo.indexOf(' ')).trim(); //dadosEnvio.nome_completo.substring(0, dadosEnvio.nome_completo.indexOf(' ') + 1).trim();
    // retorno['sobrenome'] = dadosEnvio.nome_completo.substring(dadosEnvio.nome_completo.indexOf(' ') + 1).trim();

    return retorno;
  };

  // const handleInputs = (event) => {
  //   const target = event.target;
  //   let value = target.type == 'checkbox' ? target.checked : target.value;
  //   dados[target.name] = value;
  //   setDados({ ...dados });
  // };

  // const validarDados = () => {
  //   if (dados.telefone) {
  //     //Validar Telefone
  //     if (dados.telefone.length < 10 || dados.telefone.length > 11 || isNaN(dados.telefone)) {
  //       toast.error('Erro ao validar dados! Telefone está e um formato incorreto', { containerId: 'modalToast' });
  //       return false;
  //     }
  //   }

  //   if (dados.nome_completo == '' || dados.nome_completo == null || dados.nome_completo == undefined) {
  //     toast.error('Erro ao validar dados! Informe seu nome completo', { containerId: 'modalToast' });
  //     return false;
  //   }

  //   if (dados.email == '' || dados.email == null || dados.email == undefined || !ValidarEmail(dados.email)) {
  //     toast.error('Erro ao validar dados! Email está em um formato incorreto', { containerId: 'modalToast' });
  //     return false;
  //   }

  //   if (dados.cpf != undefined && dados.cpf != null && dados.cpf != '') {
  //     if (isNaN(dados.cpf) || !ValidarCPF(dados.cpf)) {
  //       toast.error('Erro ao validar dados! CPF está incorreto', { containerId: 'modalToast' });
  //       return false;
  //     }
  //   }

  //   if (dados.senha == undefined || dados.senha == '' || dados.senha == null) {
  //     toast.error('Erro ao validar dados! Campo Senha não pode estar vazio', { containerId: 'modalToast' });
  //     return false;
  //   }

  //   return true;
  // };

  const handleValidForm = async (form, e) => {
    e.preventDefault();

    setModalLoading(true);

    form.idloja = dadosApp.IdLoja;

    const dadosCliente = handleDadosEnvio(form);
    const response = await SalvarDadosCliente(dadosCliente);

    setModalLoading(false);

    if (response.data?.Retorno?.status === 1) {
      toast.error(response.data.Retorno.msg, { containerId: 'modalToast' });
      return;
    }

    if (response.data?.Usuario) {
      form.id = response.data.Usuario.id;
      dadosCliente.id = form.id;
      setDados(dadosCliente);
    }

    const temp = document.getElementsByClassName('modal-title');
    let title = '';
    if (temp.length > 0) title = temp[0]?.textContent;

    // loja do plínio
    // if (dadosApp.IdLoja === 10602) {
    if (
      title !== 'meus dados' && // se estiver cadastrando e for sem autenticação
      dadosApp.Empresa.Config.permitir_cadastro_sem_autenticacao === 1 &&
      response.data.Usuario.ativo === 1
    ) {
      SaveUser(dadosApp.IdLoja, dadosCliente, setUser);
      toast.success(`Bem Vindo ${dadosCliente.nome}!`, { containerId: 'toastGeral' });
      closeModal();
    } else {
      if (user.id === 0 || isNaN(user.id)) {
        //|| isLogged
        showHideModalSMS(); // autenticacao do usuario que se cadastrou agora
      } else {
        SaveUser(dadosApp.IdLoja, dadosCliente, setUser);
        toast.success('Seus dados foram atualizados com sucesso!', { containerId: 'toastGeral' });
        closeModal();
      }
    }
  };

  // const showHideModalLoading = () => {
  //   setModalLoading(modalLoading === 'none' ? 'block' : 'none');
  // };

  // const handleCadastro = async () => {
  //   //if (!validarDados()) return;
  //   setModalLoading('block');

  //   const response = await SalvarDadosCliente(handleDadosEnvio(dados));

  //   setModalLoading('none');

  //   if (response.data.Retorno) {
  //     if (response.data.Retorno.status == 1) {
  //       toast.error(response.data.Retorno.msg, { containerId: 'modalToast' });
  //       return;
  //     }
  //   }

  //   if (response.data.Usuario) {
  //     dados.id = response.data.Usuario.id;
  //     setDados(dados); // correção
  //     //setDados({ ...dados, id: response.data.Usuario.id });
  //   }

  //   // loja do plínio
  //   if (dadosApp.IdLoja === 10602) {
  //     SaveUser(dadosApp.IdLoja, handleDadosEnvio(dados), setUser);
  //     toast.success(`Bem Vindo ${dados.nome}!`, { containerId: 'toastGeral' });
  //     closeModal();
  //   } else {
  //     if (isEdicao === false) {
  //       showHideModalSMS();
  //     } else {
  //       SaveUser(dadosApp.IdLoja, handleDadosEnvio(dados), setUser);
  //       toast.success('Dados do usuário atualizados com suscesso!', { containerId: 'toastGeral' });
  //       closeModal();
  //     }
  //   }
  // };

  // useEffect(() => {
  //   let val = user.id > 0;
  //   setIsEdicao(val);
  //   if (val) setDados(handleDadosEdicao(user));
  // }, [user]);

  // useEffect(() => {
  //   const usuario = GetUsuario(dadosApp.IdLoja);
  //   if (usuario) {
  //     let val = usuario.id > 0;
  //     setIsEdicao(val);
  //     if (val) {
  //       setDados(handleDadosEdicao(usuario));
  //     }
  //   }
  // }, [dadosApp.IdLoja]);

  return (
    <div>
      <div className={'modal-content-dialog cardShadow'} style={{ margin: 10, border: 'none', marginTop: 20 }}>
        <form onSubmit={handleSubmit(handleValidForm)}>
          <div className={'form-group'}>
            <LabelForm text={'Nome Completo'} labelFor={'nome_completo'} />
            <input
              type={'text'}
              placeholder={''}
              className={errors.nome_completo ? 'form-control form-control-error' : 'form-control'}
              //name="nome_completo"
              //value={dados.nome_completo}
              //onChange={handleInputs}
              {...register('nome_completo', {
                validate: (value) => {
                  if (value === '' || value === null || value === undefined) return false;
                  return true;
                },
              })}
            />
            <i className="material-icons">spellcheck</i>
            {errors.nome_completo && (
              <p className="form-errors" style={{ marginTop: 10, fontSize: 12 }}>
                Informe o seu nome completo
              </p>
            )}
          </div>
          <div className={'form-group'}>
            <LabelForm text={'E-mail'} labelFor={'email'} />
            <input
              type={'text'}
              placeholder={''}
              className={errors.email ? 'form-control form-control-error' : 'form-control'}
              // name="email"
              // value={dados.email}
              // onChange={handleInputs}
              disabled={isLogged} // user.id > 0
              {...register('email', {
                validate: (value) => {
                  if (value === '' || value === null || value === undefined || !ValidarEmail(value)) return false;
                  return true;
                },
              })}
            />
            <i className="material-icons">mail_outline</i>
            {errors.email && (
              <p className="form-errors" style={{ marginTop: 10, fontSize: 12 }}>
                Email inválido
              </p>
            )}
          </div>
          <div className={'form-group'}>
            <LabelForm text={'Senha'} labelFor={'senha'} />
            <input
              type={'password'}
              placeholder={''}
              className={errors.senha ? 'form-control form-control-error' : 'form-control'}
              // name="senha"
              // value={dados.senha}
              // onChange={handleInputs}
              {...register('senha', {
                validate: (value) => {
                  if (value === undefined || value === '' || value === null) return false;
                  return true;
                },
              })}
            />
            <i className="material-icons">lock_outline</i>
            {errors.senha && (
              <p className="form-errors" style={{ marginTop: 10, fontSize: 12 }}>
                Senha inválida
              </p>
            )}
          </div>
          <div className={'form-group'}>
            <LabelForm text={'Telefone com DDD'} labelFor={'telefone'} />
            <input
              type={'text'}
              placeholder={''}
              className={errors.telefone ? 'form-control form-control-error' : 'form-control'}
              // name="telefone"
              // value={dados.telefone}
              // onChange={handleInputs}
              disabled={isLogged} // user.id > 0
              {...register('telefone', {
                validate: (value) => {
                  if (value?.length < 10 || value?.length > 11 || isNaN(value)) return false;
                  return true;
                },
              })}
            />
            <i className="material-icons">local_phone</i>
            {errors.telefone && (
              <p className="form-errors" style={{ marginTop: 10, fontSize: 12 }}>
                Telefone Inválido
              </p>
            )}
          </div>
          {isLogged && ( // user.id > 0
            <>
              <div className="form-group-col2">
                <div className={'form-group'}>
                  <LabelForm text={'CPF'} labelFor={'cpf'} />
                  <input
                    type={'text'}
                    placeholder={''}
                    className={'form-control input-full'}
                    // name="cpf"
                    // value={dados.cpf}
                    // onChange={handleInputs}
                    {...register('cpf', {
                      validate: (value) => {
                        if (value !== undefined && value !== null && value !== '') {
                          if (isNaN(value) || !ValidarCPF(value)) return false;
                          return true;
                        }
                      },
                    })}
                  />
                </div>
                <div className={'form-group'}>
                  <LabelForm text={'Data Nascimento'} labelFor={'nascimento'} />
                  <input
                    type={'date'}
                    placeholder={''}
                    className={'form-control input-full'}
                    // name="data_aniversario"
                    // value={dados.data_aniversario}
                    // onChange={handleInputs}
                    {...register('data_aniversario', {
                      //validate: (value) => value !== '',
                    })}
                  />
                </div>
              </div>

              <div className={'form-group'}>
                <LabelForm text={'Sexo'} labelFor={'nome_completo'} />
              </div>
              <div className="radio-area">
                <label className="container-radio">
                  Masculino
                  {/* <input type="radio" value="M" name="sexo" onChange={handleInputs} defaultChecked={dados.sexo == 'M'} /> */}
                  <input
                    type="radio"
                    value="M"
                    {...register('sexo')} // defaultChecked={dados.sexo == 'M'}
                  />
                  <span className="checkmark"></span>
                </label>
                <label className="container-radio">
                  {/* <input type="radio" value="F" name="sexo" onChange={handleInputs} defaultChecked={dados.sexo == 'F'} /> */}
                  <input
                    type="radio"
                    value="F"
                    //name="sexo"
                    {...register('sexo')} //defaultChecked={dados.sexo == 'F'}
                  />
                  Feminino
                  <span className="checkmark"></span>
                </label>
              </div>
            </>
          )}

          <div className="padTop20 padBottom20">
            <Button
              type={'submit'}
              text={`${user.id > 0 ? 'Salvar' : 'Cadastrar'}`}
              className="btn_1 btnGradient width-full clearfix" //onClick={handleCadastro}
            />
          </div>

          {/* {user.id > 0 && (
            <div className="padTop20 padBottom20">
              <div className="info-green">
                <a href="#" onClick={showHideModalExcluirConta}>
                  excluir minha conta
                </a>
              </div>
            </div>
          )} */}
        </form>
      </div>

      {isLogged && ( //user.id > 0
        <div className="padTop20 padBottom20">
          <div className="info-green">
            <a href="#" onClick={showHideModalExcluirConta}>
              excluir minha conta
            </a>
          </div>
        </div>
      )}

      {modalExcluirConta == 'block' && (
        <Modal
          title="Excluir Conta"
          isFooter={false}
          visibility={modalExcluirConta}
          param={{ closeCadastro: closeModal }}
          page="EXCLUIR_CONTA"
          btnOnClickClose={showHideModalExcluirConta}
        />
        //customPosition="modal-position-bottom"
      )}

      {modalSMS == 'block' && (
        <Modal
          title="Autentique sua conta"
          isFooter={false}
          visibility={modalSMS}
          param={{ cliente: dados, closeCadastro: closeModal }}
          page="SMS"
          btnOnClickClose={showHideModalSMS}
          customPosition="modal-position-bottom"
        />
      )}

      {modalLoading && (
        <Modal
          title=""
          isFooter={false}
          visibility={modalLoading ? 'block' : 'none'}
          param=""
          page="LOADING"
          btnOnClickClose={() => setModalLoading(false)}
          customPosition="loading-modal"
        />
      )}
    </div>
  );
};

MeusDados.propTypes = {
  closeModal: P.func,
};
